export class DownloadGdsgObjectsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "role",
            "baseName": "role",
            "type": "DownloadGdsgObjectsRequestRoleEnum",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "keys",
            "baseName": "keys",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DownloadGdsgObjectsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var DownloadGdsgObjectsRequestRoleEnum;
(function (DownloadGdsgObjectsRequestRoleEnum) {
    DownloadGdsgObjectsRequestRoleEnum["Primary"] = "primary";
    DownloadGdsgObjectsRequestRoleEnum["DrReplica"] = "drReplica";
})(DownloadGdsgObjectsRequestRoleEnum || (DownloadGdsgObjectsRequestRoleEnum = {}));
